import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo, Spinner } from "@/components/common";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/auth/forgot-password", { email });
            setSent(true);
        } catch (err) {
            toast.error(formatApiError(err.response?.data?.detail));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex min-h-screen flex-col bg-background">
            <div className="p-5"><Logo /></div>
            <div className="flex flex-1 items-center justify-center px-5 pb-16">
                <div className="w-full max-w-md rounded-3xl bg-card p-8 shadow-sm">
                    <h1 className="font-display text-3xl font-700 tracking-tight text-primary">Reset password</h1>
                    {sent ? (
                        <p className="mt-4 text-sm text-muted-foreground" data-testid="forgot-sent">
                            If an account exists for {email}, we've sent a reset link. Check your inbox.
                        </p>
                    ) : (
                        <form onSubmit={submit} className="mt-6 space-y-4">
                            <p className="text-sm text-muted-foreground">Enter your email and we'll send you a reset link.</p>
                            <div><Label>Email</Label><Input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5" /></div>
                            <Button type="submit" disabled={loading} data-testid="forgot-submit" className="w-full rounded-full bg-primary hover:bg-primary/90">
                                {loading ? <Spinner className="h-5 w-5 border-white/40 border-t-white" /> : "Send reset link"}
                            </Button>
                        </form>
                    )}
                    <p className="mt-6 text-center text-sm"><Link to="/login" className="text-accent hover:underline">Back to sign in</Link></p>
                </div>
            </div>
        </div>
    );
}
